var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cnehl-main",style:({ 
    'width': '100%',
    'height': '100%',
    'position': 'relative'})},[_c('div',{staticClass:"urgency",style:({
      'width': ((90 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((12 * _vm.zoomLevel) + "px"),
      'left': ((220 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Urgent'] == '1' ? 'URGENT!!' : '')+"\n    ")]),_c('div',{staticClass:"printed-on",style:({
      'width': ((330 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((12 * _vm.zoomLevel) + "px"),
      'left': ((325 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      PRINTED ON: "+_vm._s(_vm.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy'))+" - "+_vm._s(_vm.$dateTime.getDateTime(new Date(), 'HH:mm'))+"\n    ")]),_c('div',{staticClass:"by",style:({
      'width': ((140 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((12 * _vm.zoomLevel) + "px"),
      'left': ((660 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      BY: "+_vm._s(_vm.job['userid'])+"\n    ")]),_c('div',{staticClass:"reprint",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((29 * _vm.zoomLevel) + "px"),
      'left': ((660 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {@Reprint} ")]),_c('div',{staticClass:"fumigation",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((47 * _vm.zoomLevel) + "px"),
      'left': ((660 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Fumigation'] == '1' ? 'FUMIGATION' : '')+"\n    ")]),_c('div',{staticClass:"last-day",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((25 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((104 * _vm.zoomLevel) + "px"),
      'left': ((660 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.getLastDay())+"\n    ")]),_c('div',{staticClass:"office-hour",style:({
      'width': ((150 * _vm.zoomLevel) + "px"),
      'height': ((25 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((134 * _vm.zoomLevel) + "px"),
      'left': ((660 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['OfficeHours'] ? _vm.cn['OfficeHours'] == '1' ? 'OFFICE HOURS' : '24 HOURS' : '')+"\n    ")]),_c('div',{staticClass:"rot-no",style:({
      'width': ((299 * _vm.zoomLevel) + "px"),
      'height': ((25 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((104 * _vm.zoomLevel) + "px"),
      'left': ((51 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      ROT No: "+_vm._s(_vm.job['Request No'])+"\n    ")]),_c('div',{staticClass:"cust-ref-no",style:({
      'width': ((240 * _vm.zoomLevel) + "px"),
      'height': ((25 * _vm.zoomLevel) + "px"),
      'font-size': ((12 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((134 * _vm.zoomLevel) + "px"),
      'left': ((51 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Cust Ref No'])+"\n    ")]),_c('div',{staticClass:"pickup",style:({
      'width': ((299 * _vm.zoomLevel) + "px"),
      'height': ((39 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((183 * _vm.zoomLevel) + "px"),
      'left': ((51 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['PickUp'])+"\n    ")]),_c('div',{staticClass:"contact-person",style:({
      'width': ((218 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((223 * _vm.zoomLevel) + "px"),
      'left': ((132 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Contact Person} ")]),_c('div',{staticClass:"tel",style:({
      'width': ((278 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((237 * _vm.zoomLevel) + "px"),
      'left': ((72 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Tel} ")]),_c('div',{staticClass:"cn-no",style:({
      'width': ((204 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((183 * _vm.zoomLevel) + "px"),
      'left': ((365 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ConsignmentNo'])+"\n    ")]),_c('div',{staticClass:"datetime",style:({
      'width': ((179 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((183 * _vm.zoomLevel) + "px"),
      'left': ((580 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(Date.parse(_vm.job['Last Update']) ? _vm.$dateTime.getDateTime(new Date(_vm.job['Last Update']), 'dd/MM/yyyy HH:mm') : '')+"\n    ")]),_c('div',{staticClass:"datetime-required",style:({
      'width': ((394 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((228 * _vm.zoomLevel) + "px"),
      'left': ((365 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(Date.parse(_vm.cn['RequiredTime']) ? ((_vm.$dateTime.getDateTime(new Date(_vm.cn['RequiredTime']), 'dd/MM/yyyy HH:mm')) + " {Req Time Desc}") : '')+" ")]),_c('div',{staticClass:"deliver-to",style:({
      'width': ((299 * _vm.zoomLevel) + "px"),
      'height': ((39 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((274 * _vm.zoomLevel) + "px"),
      'left': ((51 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Deliver} ")]),_c('div',{staticClass:"contact-person-del",style:({
      'width': ((218 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((311 * _vm.zoomLevel) + "px"),
      'left': ((132 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Contact Person Del} ")]),_c('div',{staticClass:"tel-del",style:({
      'width': ((278 * _vm.zoomLevel) + "px"),
      'height': ((18 * _vm.zoomLevel) + "px"),
      'font-size': ((10 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((325 * _vm.zoomLevel) + "px"),
      'left': ((72 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Tel Del} ")]),_c('div',{staticClass:"ladenMT-dropoff",style:({
      'width': ((395 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((271 * _vm.zoomLevel) + "px"),
      'left': ((364 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['DropOff'])+"\n    ")]),_c('div',{staticClass:"size-type",style:({
      'width': ((202 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((315 * _vm.zoomLevel) + "px"),
      'left': ((365 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContSize'])+" "+_vm._s(_vm.cn['ContType'])+"\n    ")]),_c('div',{staticClass:"seal",style:({
      'width': ((180 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((315 * _vm.zoomLevel) + "px"),
      'left': ((579 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['SealNo'])+"\n    ")]),_c('div',{staticClass:"cont-no",style:({
      'width': ((300 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((356 * _vm.zoomLevel) + "px"),
      'left': ((50 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContainerNo'])+"\n    ")]),_c('div',{staticClass:"cont-operator",style:({
      'width': ((397 * _vm.zoomLevel) + "px"),
      'height': ((23 * _vm.zoomLevel) + "px"),
      'font-size': ((14 * _vm.zoomLevel) + "px"),
      'position': 'absolute',
      'top': ((355 * _vm.zoomLevel) + "px"),
      'left': ((362 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['ContOperator'])+"\n    ")]),_c('div',{staticClass:"commodity",style:({
      'width': ((709 * _vm.zoomLevel) + "px"),
			'height': ((23 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((394 * _vm.zoomLevel) + "px"),
			'left': ((50 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Commodity'])+"\n    ")]),_c('div',{staticClass:"vessel-name",style:({
      'width': ((351 * _vm.zoomLevel) + "px"),
			'height': ((23 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((432 * _vm.zoomLevel) + "px"),
			'left': ((49 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Vessel Name'])+" - "+_vm._s(_vm.job['Voy No'])+"\n    ")]),_c('div',{staticClass:"vessel-code",style:({
      'width': ((347 * _vm.zoomLevel) + "px"),
			'height': ((23 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((429 * _vm.zoomLevel) + "px"),
			'left': ((411 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Vessel No'])+" - "+_vm._s(Date.parse(_vm.job['POD ETA']) ? _vm.$dateTime.getDateTime(new Date(_vm.job['POD ETA']), 'dd/MM/yyyy HH:mm') : '')+"\n    ")]),_c('div',{staticClass:"loading-port",style:({
      'width': ((709 * _vm.zoomLevel) + "px"),
			'height': ((23 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((472 * _vm.zoomLevel) + "px"),
			'left': ((50 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['LoadDischargePort'])+"\n    ")]),_c('div',{staticClass:"shipper-forwarder",style:({
      'width': ((710 * _vm.zoomLevel) + "px"),
			'height': ((23 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((506 * _vm.zoomLevel) + "px"),
			'left': ((49 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      {Shipper} / {Forwarder}\n    ")]),_c('div',{staticClass:"requested-by",style:({
      'width': ((710 * _vm.zoomLevel) + "px"),
			'height': ((30 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((544 * _vm.zoomLevel) + "px"),
			'left': ((49 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Requested By'])+"\n    ")]),_c('div',{staticClass:"shipping-agent",style:({
      'width': ((710 * _vm.zoomLevel) + "px"),
			'height': ((30 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((569 * _vm.zoomLevel) + "px"),
			'left': ((49 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      Shipping Agent: "+_vm._s(_vm.job['Shipping Agt Name'])+"\n    ")]),_c('div',{staticClass:"remarks",style:({
      'width': ((350 * _vm.zoomLevel) + "px"),
			'height': ((32 * _vm.zoomLevel) + "px"),
			'font-size': ((14 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((616 * _vm.zoomLevel) + "px"),
			'left': ((48 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['Remarks'])+"\n    ")]),_c('div',{staticClass:"job-type",style:({
      'width': ((345 * _vm.zoomLevel) + "px"),
			'height': ((15 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((609 * _vm.zoomLevel) + "px"),
			'left': ((420 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      Job Type: "+_vm._s(_vm.job['Job Type'])+"\n    ")]),_c('div',{staticClass:"handling",style:({
      'width': ((345 * _vm.zoomLevel) + "px"),
			'height': ((15 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((619 * _vm.zoomLevel) + "px"),
			'left': ((420 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['HandlingType'])+"\n    ")]),_c('div',{staticClass:"bookingrefno",style:({
      'width': ((345 * _vm.zoomLevel) + "px"),
			'height': ((15 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((629 * _vm.zoomLevel) + "px"),
			'left': ((420 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.job['Booking Ref No'])+"\n    ")]),_c('div',{staticClass:"gatepass",style:({
      'width': ((710 * _vm.zoomLevel) + "px"),
			'height': ((15 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((639 * _vm.zoomLevel) + "px"),
			'left': ((420 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      Gate Pass: {Gatepass}\n    ")]),_c('div',{staticClass:"delivery-type",style:({
      'width': ((300 * _vm.zoomLevel) + "px"),
			'height': ((30 * _vm.zoomLevel) + "px"),
			'font-size': ((10 * _vm.zoomLevel) + "px"),
			'position': 'absolute',
			'top': ((994 * _vm.zoomLevel) + "px"),
			'left': ((40 * _vm.zoomLevel) + "px"), })},[_vm._v("\n      "+_vm._s(_vm.cn['DeliveryType'] == 'SL' ? 'SIDELOADER' : '')+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }